import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/style/select.scss';

const citiesData =
{
	chinese: [
		{
			area: "华南区",
			list: [
				{
					name: "深圳市",
					value: "2"
				},
				{
					name: "广州市",
					value: "2"
				},
				{
					name: "佛山市",
					value: "2"
				}
			]
		},
		{
			area: "华东区",
			list: [
				{
					name: "上海市",
					value: "7"
				},
				{
					name: "义乌市",
					value: "12"
				}
			]
		},
		{
			area: "华西区",
			list: [
				{
					name: "长沙市",
					value: "17"
				},
				{
					name: "成都市",
					value: "8"
				},
				{
					name: "重庆市",
					value: "96"
				},
				{
					name: "武汉市",
					value: "95"
				}
			]
		},
		{
			area: "东南区",
			list: [
				{
					name: "福州市",
					value: "2"
				},
				{
					name: "厦门市",
					value: "2"
				},
				{
					name: "莆田市",
					value: "2"
				},
				{
					name: "泉州市",
					value: "2"
				}
			]
		}
	]
}
export default class CityDom extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: {},
			index: 0,
			current: [],
			status:false
		};
	}
	componentDidMount() {

		this.setState({
			current: citiesData.chinese[0].list,
			data: citiesData
		})
	}
	changeArea(i) {
		this.state.index = i
		this.setState({
			current: citiesData.chinese[i].list
		})
	}
	render() {
		let status = this.props.parent.state.cityStatus
		let areas = citiesData.chinese.map((item, key) => {
			return (
				<span style={{ fontSize: 10 + 'px', flex: 1,textAlign:"center" }} className={this.state.index === key ? "active" : "item"} onClick={() => {
					this.changeArea(key)
				}} key={key}>{item.area}</span>

			)

		})
		let cityOption = this.state.current.map((item, key) => {
			return (
				<span style={{ fontSize: 12 + 'px' }} key={key} onClick={
					() => {
						this.props.parent.state.cityName = item.name
						let obj = {
							value: item.value,
							name: item.name
						}
						status = false
						this.props.parent.getChildrenMsg(this, obj)
					}
				} value={item.value}>{item.name}</span>
			)

		})
		return (
			<div className={status == true ? "pms-select-on" : "pms-select-off"}>
				<div className="area">
					{areas}
				</div>
				<div className='pms-select-span'>
					{cityOption}
				</div>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./public/views/selectCity.js